import categorizeFeaturesProjectHelper from "@/src-refactor/modules/shared/helpers/categorize-features-project.helpers";

const featureProjectAdapter = (data: any) => {
  const values = categorizeFeaturesProjectHelper(data);
  return values;
};

export default featureProjectAdapter;
